// T2-6085: pure helpers for the Photo Announce targeted ID-list upload,
// extracted from FileUpload.vue so the parsing/formatting logic is unit-testable.

export const KNOWN_HEADER_LABELS = ["hygienistid", "locationid", "dentistid", "id"];

/**
 * Drop only a recognized header row (e.g. "hygienistId"/"locationId"/"id").
 * Deliberately NOT "any non-numeric first row" so a malformed ID like "123abc"
 * or "1.5" is kept and reported invalid by the server rather than silently
 * swallowed as a header.
 */
export function dropKnownHeaderRow(rows: string[]): string[] {
  if (rows.length === 0) {
    return rows;
  }
  const first = String(rows[0] === null || rows[0] === undefined ? "" : rows[0])
    .trim()
    .toLowerCase();
  return KNOWN_HEADER_LABELS.includes(first) ? rows.slice(1) : rows;
}

/** Human-friendly label for an invalid-row reason from parseTargetIdFile. */
export function reasonLabel(reason: string): string {
  switch (reason) {
    case "not_a_number":
      return "Not a number";
    case "duplicate":
      return "Duplicate";
    case "unknown_hygienistId":
      return "No such hygienist ID";
    case "unknown_locationId":
      return "No such location ID";
    default:
      return reason;
  }
}

/** Compact human-readable file size. */
export function formatBytes(bytes: number): string {
  if (bytes < 1024) {
    return `${bytes} B`;
  }
  if (bytes < 1024 * 1024) {
    return `${(bytes / 1024).toFixed(1)} KB`;
  }
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
